import {
    ReactElement,
    HTMLAttributes
} from "react";
import { useNavigate } from "react-router-dom";

interface Props extends HTMLAttributes<HTMLElement> {
    title: string;
    icon?: string;
    myStyle?: string;
    link?:string;
}

export function CategoryCard({ title, icon, myStyle , link }: Props): ReactElement {
  const navigation = useNavigate();

    return (
        <div className={`${myStyle && myStyle} category-card`} onClick={()=>link ? navigation(`${link}`) : null}>
            <img src={icon} className="icon" alt="هامرز" />
            <span className="title">
                {title}
            </span>
        </div>
    )
}
export default CategoryCard;